<!--
 * @description: 代理-页头（顶部-信息）
 * @Author: Jay
 * @Date: 2026-03-02 10:48:44
 * @LastEditors: Jay
 * @LastEditTime: 2026-03-02 13:33:53
-->
<template>
  <div>
    <div class="text-xi flex align-center margin-tb-xs gesture-pointer">
      <el-image class="menu-img" :src="menuIcon" fit="fill"></el-image>
      <span class="margin-lr-x text-gray" v-show="pageName != ''">/</span>
      <span class="line-color" v-show="pageName != ''">{{ pageName }}</span>
      <span class="margin-lr-x text-gray">/</span>
      <span class="line2-color">{{ pageTitle }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 菜单图片
    menuIcon: {
      // type: String,
      default: require("@/assets/menuApp/icon-menu1.png"),
    },
    // 菜单标题
    pageName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // 页面标题
      pageTitle: "",
    };
  },
  created() {
    // console.log(this.$route, "页面标题--");
    // 页面标题
    this.pageTitle = this.$route.meta.title || "";
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
// 顶部导航图标
.menu-img {
  width: 15px;
  height: 15px;
  padding: 3px;
  background-color: #78808c;
  border-radius: 50%;
}

.text-size {
  font-size: 14px;
}

.line-color {
  color: #78808c;
}

.line2-color {
  color: #1d2129;
  font-weight: 700;
}
</style>
